// extracted by mini-css-extract-plugin
export default {"dashboardContent":"Ss7F2__dashboardContent","contentSection":"ievBX__contentSection"};